// extracted by mini-css-extract-plugin
export default {"cls1":"NewsHeader-cls1___cbc730e51c313517dfc","cls2":"NewsHeader-cls2__dacb17c4beafe7366b1d NewsHeader-cls1___cbc730e51c313517dfc"};